export const changeInputCSS = (invalid: boolean, touched: boolean, type: string) => {
  if (invalid && touched) {
    return 'required-input border-red';
  }
};
